import { useState, useContext, useEffect, lazy, Suspense, memo } from "react";
import ContextApp from "./../../../core/contexts/context.app";
import isNil from "lodash/isNil";
import has from "lodash/has";
import isObject from "lodash/isObject";
import ServiceStorage from "../../../core/services/service.storage";
import { useMediaQuery } from "../../../core/hooks/useMediaQuery";

const SelectCityModal = lazy(() => import(/* webpackChunkName: "SelectCityModal" */ "./SelectCityModal"));
const MobileHeader = lazy(() => import(/* webpackChunkName: "MobileHeader" */ "./MobileHeader"))
const DesktopHeader = lazy(() => import(/* webpackChunkName: "DesktopHeader" */ "./DesktopHeader"))

function HeaderNav() {
  const ctx = useContext(ContextApp);
  const [showModalSelectCity, setShowModalSelectCity] = useState(false);
  const isMobile = useMediaQuery('(max-width: 991px)');

  // ---جهت بستن مدال در مواقعی که هر جای صفحه کلیک شد -----------------y-

  useEffect(() => {
    (async () => {
      //---------------- ذخیره در استوریج --------------------
      const storageCity = ServiceStorage.getCity();
      if (
        !isNil(storageCity) &&
        has(
          storageCity,
          "selectedCity" && isObject(storageCity.selectedCity)
        )
      ) {
        ServiceStorage.setSelectedCity(ctx.selectedCity);
      }
      //-------------------------------------------------------
    })();
  }, [ctx.selectedCity]);


  return (
    <>
      <Suspense fallback={null}>
        {showModalSelectCity && (
          <SelectCityModal
            showModalSelectCity={showModalSelectCity}
            setShowModalSelectCity={setShowModalSelectCity}
          />
        )}
      </Suspense>
      {/* {show && <LoginModal show={show} handleClose={handleClose} />} */}

      {isMobile ? (
        /************ حالت موبایل ***********************************/
        <MobileHeader setShowModalSelectCity={setShowModalSelectCity} />
      ) : (
        /************ حالت دسکتاپ ***********************************/
        <DesktopHeader setShowModalSelectCity={setShowModalSelectCity} />

      )}
    </>
  );
}

export default memo(HeaderNav);
